import { inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';

type MetaInfo = {
  metaTitle: string | undefined;
};
@Injectable({
  providedIn: 'root',
})
export class SEOService {
  private titleService = inject(Title);

  constructor() {}

  // Updates or adds the new tag
  public setMetaTags(metaInfo: MetaInfo) {
    const { metaTitle } = metaInfo;

    // Home Page
    if (metaTitle === `JFW Platform Portal`) {
      this.titleService.setTitle(`Jim's Formal Wear | JFW Platform Portal`);
    } else if (metaTitle) {
      const jimsTitle = `${metaTitle} | JFW Platform Portal`;
      this.titleService.setTitle(jimsTitle);
    } else {
      // Fall back homepage?
      this.titleService.setTitle(`Jim's Formal Wear | JFW Platform Portal`);
    }
  }
}
